module.exports = __webpack_public_path__ + "static/img/10.92f8a11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresas/10.png
// module id = S2GO
// module chunks = 0